import { config } from '~/config/metrics';

import type { MetricSettings } from '@amp/web-apps-metrics-8';
import type {
    LintedMetricsEvent,
    MetricsFields,
} from '@jet/environment/types/metrics';

/**
 * Generates a metric settings for Metrics class.
 *
 * @param context - app context map
 * @returns MetricSettings
 */
export const makeMetricsSettings = (
    context: Map<string, unknown>,
): MetricSettings => {
    return {
        shouldEnableFunnelKit: function (): boolean {
            return false;
        },
        getConsumerId: async function (): Promise<string> {
            return null;
        },
        // TODO: Turn on clickstream metrics when we ready
        // rdar://147234043 (Turn on clickstream metric for classical)
        suppressMetricsKit: true,
    };
};

type ProcessEvent = (fields: MetricsFields) => Promise<LintedMetricsEvent>;
/**
 * Generates the processEvent function used by Metrics class.
 *
 * This function allows an app to hook into the processing stage of a
 * metric pipeline to add or modify the fields before it is sent to the server.
 *
 */
export const makeProcessEventFn = (): ProcessEvent => {
    return async (fields: MetricsFields): Promise<LintedMetricsEvent> => {
        return {
            fields: {
                topic: config.clickstream.topic,
                ...fields,
            },
        };
    };
};
